import { Component, DestroyRef, OnInit, ViewContainerRef, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { filter, map, switchMap } from "rxjs/operators";
import { Location } from "@angular/common";
import { environment } from "src/environments/environment";
import { Constants } from "src/app/_consts/constants";
import dateFormats from "../const/date-formats";
import { SharedService } from "src/app/_shared/shared.service";
import { HttpPlus } from "../http-plus";
import { AuthService, SSO_LOGOUT_KEY } from "../auth.service";
import { NewsModalComponent } from "../modals/news-modal/news-modal.component";
import { NgxSmartModalService } from "ngx-smart-modal";
import { Fce } from "../fce";
import { NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "s-header",
  template: "",
  imports: [],
})
export class SHeaderComponent implements OnInit {
  title: string = "";
  app: string;
  languages = Constants.LANGUAGES;
  version = environment.version;
  dateFormats = dateFormats;

  public baseRights: any = {};
  public messages = null;
  public newMessages = false;
  public showBack: boolean = false;
  public hideIfNotLogged: boolean = false;
  private destroyRef = inject(DestroyRef);

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    public shared: SharedService,
    protected http: HttpPlus,
    protected auth: AuthService,
    protected modal: NgxSmartModalService,
    protected location: Location,
    protected offcanvasService: NgbOffcanvas,
  ) {}

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((routeEvent) => routeEvent instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map((activatedRoute) => activatedRoute.firstChild),
        switchMap((firstChild) => firstChild?.data),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((data) => {
        this.title = data.title;
        this.app = data.app;
        this.showBack = !data.isMainPage;
        this.hideIfNotLogged =
          !!data.hideHeaderIfNotLogged && !this.shared.isLoggedIn();
      });

    this.shared.rightsAllWatch.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((rights) => {
      if (rights) {
        console.log(rights);
        this.baseRights = rights[Constants.MOD_BASE];
      }
    });

    this.shared.messages.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((messages) => {
      if (messages) {
        this.messages = Fce.convertForClientArray(messages);
        this.newMessages = this.messages.some((e) => {
          return e.is_new;
        });
      }
    });

    this.shared.getAnyWatch(Constants.BROADCAST).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((br) => {
      if (br)
        switch (br.type) {
          case "CHANGE_LANG":
            this.changeLanguage(br.callback);
            break;
        }
    });
  }

  goBack() {
    if (
      this.app &&
      this.app != Constants.MOD_BASE &&
      this.shared.loadedIframe
    ) {
      this.shared.loadedIframe.goBack();
    } else {
      const openedModals = this.modal.getOpenedModals();
      if (openedModals?.length > 0) {
        this.modal.closeLatestModal();
      } else {
        this.location.back();
      }
    }
  }

  goHome() {
    if (
      this.app &&
      this.app != Constants.MOD_BASE &&
      this.shared.loadedIframe
    ) {
      this.shared.loadedIframe.goHome();
    } else {
      let route = this.router.url;
      if (route.startsWith("/")) route = route.substring(1);
      route = route.split("/")[0];
      const conf = this.router.config.find((r) => r.path == route);
      if (route && conf?.path && !environment.multiApp) {
        this.router.navigate([conf.path]);
      } else {
        this.router.navigate(["/dashboard"]);
      }
    }
  }

  openMenu(content, start = false) {
    this.offcanvasService.open(content, { position: start ? "start" : "end" });
  }

  async logout() {
    const response = await this.http.post("logout");
    console.log(response);
    // Po SSO přihlášení ukonči i Keycloak session — jinak by další klik na SSO
    // tlačítko (sdílený PC) přihlásil bez hesla předchozího uživatele.
    const ssoLogout = this.shared.storageGet(SSO_LOGOUT_KEY);
    this.shared.storageDelete(SSO_LOGOUT_KEY);
    this.auth.logoutUser(!ssoLogout);
    if (ssoLogout) location.href = ssoLogout;
  }

  changeLanguage(lang) {
    this.shared.transService.use(lang);

    if (this.shared.transService.translations[lang]) {
      if (
        this.app &&
        this.app != Constants.MOD_BASE &&
        this.shared.loadedIframe
      )
        this.shared.loadedIframe.changeLanguage(lang);
      this.shared.storageSet("lang", lang);
      if (!environment.multiApp) this.shared.setAny("language", lang);
    } else {
      const watch = this.shared.transService.onLangChange.subscribe(() => {
        if (
          this.app &&
          this.app != Constants.MOD_BASE &&
          this.shared.loadedIframe
        )
          this.shared.loadedIframe.changeLanguage(lang);
        this.shared.storageSet("lang", lang);
        if (!environment.multiApp) this.shared.setAny("language", lang);
        watch.unsubscribe();
      });
    }
  }

  async checkMessages($event, msg, allOfThem) {
    $event.stopPropagation();
    $event.preventDefault();
    let ids = [];
    if (allOfThem) {
      ids = this.messages.map((m) => m.id_message);
    } else {
      ids.push(msg.id_message);
    }
    if (ids.length > 0) {
      const response: any = await this.http.post("msg/check", { ids });
      if (response && response.messages)
        this.shared.messages.next(response.messages);
    }
  }

  showNews() {
    this.modal
      .create("newsModal", NewsModalComponent, {
        customClass: "modal-full",
        dismissable: true,
      } as any)
      .open();
  }

  print() {
    if (
      this.app &&
      this.app != Constants.MOD_BASE &&
      this.shared.loadedIframe
    ) {
      this.shared.loadedIframe.print();
    } else window.print();
  }
}
